import { map } from 'rxjs/operators';
import _ from 'lodash';
import http from '../../helpers/APIHelper';

export const SUMMARY_ACTIONS = {
  GET_SUMMARY: '@regulatory/issummary',
  GET_SUMMARY_DATA: '@regulatory/summarydata'
};

export const INSTITUTION_ACTIONS = {
  GET_INSTITUTION_DATA: '@regulatory/institutiontreedata',
  GET_ROSTERTREE_DATA: '@regulatory/rostertreedata'
};

export const EMAIL_ACTIONS = {
  GET_TEMPLATES: '@regulatory/email/templates',
  GET_EMAIL_OBJECT: '@regulatory/email/object',
  SEND_EMAIL: '@regulatory/email/send',
  GET_REASON: '@regulatory/email/reason',
  GET_PSR: '@regulatory/email/protocol/psr'
};

export const setSummary = (flag) => (dispatch) => {
  const action = {
    type: SUMMARY_ACTIONS.GET_SUMMARY,
    payload: {
      flag
    }
  };
  dispatch(action);
};

export const queryInsitutionDetails = (token, loggerInfo, req) => (dispatch) => http
  .postWithToken(
    `${process.env.REACT_APP_ORIGIN}site-data-service/${process.env.REACT_APP_PERSON_API_VERSION}/sites/search`,
    token,
    JSON.stringify(req),
    loggerInfo
  )
  .pipe(
    map((resp) => {
      const action = {
        type: INSTITUTION_ACTIONS.GET_INSTITUTION_DATA,
        payload: {
          treeData: resp[0] ? resp[0] : req
        }
      };
      dispatch(action);
    })
  );

export const getSummaryData = (data) => (dispatch) => {
  const action = {
    type: SUMMARY_ACTIONS.GET_SUMMARY_DATA,
    payload: {
      data
    }
  };
  dispatch(action);
};

export const getTemplates = (token, loggerInfo, objType, key) => (dispatch) => {
  http.getWithToken(`esys-data-service/v1/email/object/${objType}/key/${key}/templates`, token, loggerInfo).subscribe(
    (resp) => {
      dispatch({
        type: EMAIL_ACTIONS.GET_TEMPLATES,
        payload: resp.response
      });
    },
    (error) => {
      dispatch({
        type: EMAIL_ACTIONS.GET_TEMPLATES,
        payload: error
      });
    }
  );
};

export const getEmailObject = (token, loggerInfo, postBody, tmpId) => (dispatch) => http.postWithToken(`esys-data-service/v1/email/template/${tmpId}/details`, token, postBody, loggerInfo).subscribe(
  (resp) => {
    dispatch({
      type: EMAIL_ACTIONS.GET_EMAIL_OBJECT,
      payload: resp.response
    });
  },
  (error) => {
    dispatch({
      type: EMAIL_ACTIONS.GET_EMAIL_OBJECT,
      payload: error
    });
  }
);

export const sendEmailObj = (token, loggerInfo, data, id) => (dispatch) => http.postWithToken(`esys-data-service/v1/email/template/${id}/send`, token, data, loggerInfo, 'string').pipe(
  map((resp) => {
    dispatch({
      type: EMAIL_ACTIONS.SEND_EMAIL,
      payload: resp.response
    });
    return resp;
  })
);

export const viewEmail = (token, loggerInfo, id) => (dispatch) => http.getWithToken(`esys-data-service/v1/email/id/${id}/details`, token, loggerInfo).subscribe(
  (resp) => {
    dispatch({
      type: EMAIL_ACTIONS.GET_EMAIL_OBJECT,
      payload: resp.response
    });
  },
  (error) => {
    dispatch({
      type: EMAIL_ACTIONS.GET_EMAIL_OBJECT,
      payload: error
    });
  }
);

export const getReason = (token, loggerInfo, type) => (dispatch) => http.getWithToken(`regulatory-data-service/v1/regulatory/followup/${type}/reason`, token, loggerInfo).subscribe(
  (resp) => {
    dispatch({
      type: EMAIL_ACTIONS.GET_REASON,
      payload: resp.response
    });
  },
  (error) => {
    dispatch({
      type: EMAIL_ACTIONS.GET_REASON,
      payload: error
    });
  }
);

export const deleteAttachment = (token, loggerInfo, processKey, fileName) => () => http
  .deleteWithToken(`esys-data-service/v1/email/detach/${processKey}/file/${fileName}/attachment`, token, loggerInfo)
  .pipe(map((resp) => resp.response));

export const getProcessKey = (token, loggerInfo) => () => http
  .getWithToken(`esys-data-service/v1/email/template/processkey`, token, loggerInfo, {}, 'string')
  .pipe(map((resp) => resp.response));

const filterPsr = ({ data }) => _.filter(data, (item) => ['active', 'proposed'].indexOf(item.esysStatus.toLowerCase()) > -1);

export const getProtocolPSR = (token, loggerInfo, protocol, postBody = {}) => (dispatch) => http
  .postWithToken(`protocol-data-service/v1/protocols/number/${protocol}/psrs`, token, postBody, loggerInfo)
  .subscribe(
    (resp) => {
      dispatch({
        type: EMAIL_ACTIONS.GET_PSR,
        payload: filterPsr(resp.response)
      });
    },
    (error) => {
      dispatch({
        type: EMAIL_ACTIONS.GET_PSR,
        payload: error
      });
    }
  );

export const clearProtocolPSR = () => (dispatch) => {
  dispatch({
    type: EMAIL_ACTIONS.GET_PSR,
    payload: []
  });
};

export const clearEmailObject = () => (dispatch) => {
  dispatch({
    type: EMAIL_ACTIONS.GET_EMAIL_OBJECT,
    payload: null
  });
};
